import { __assign, __rest } from "tslib";
import React from 'react';
import { Facebook } from '../icons';
import { Button } from '../Button';
export var FacebookLogoButton = function (props) {
    var buttonProps = __rest(props, []);
    return (React.createElement(Button, __assign({ type: "button" }, buttonProps, { variant: "facebook" }),
        React.createElement(Facebook, { className: "mt-1", size: "18" })));
};
//# sourceMappingURL=FacebookLogoButton.js.map